(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tender-first-year"] && !Shopify.designMode) return;
  try {
    
function initialiseTenderForms(){
  document.querySelectorAll('[data-tc-product]').forEach(root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';

    const form=root.querySelector('form');
    const inputs=[...root.querySelectorAll('[data-tc-photo]')];
    const error=root.querySelector('[data-tc-error]');
    const button=root.querySelector('button[type=submit]');
    const progress=root.querySelector('[data-tc-progress]');
    const allowedTypes=['image/jpeg','image/png','image/webp'];
    const targetBytes=600*1024;
    const maxTotalBytes=8*1024*1024;
    const maxDimension=2000;

    const showError=message=>{
      error.textContent=message;
      error.hidden=false;
      error.scrollIntoView({block:'center'});
    };

    const loadImage=file=>new Promise((resolve,reject)=>{
      const url=URL.createObjectURL(file);
      const image=new Image();
      image.onload=()=>{
        URL.revokeObjectURL(url);
        resolve(image);
      };
      image.onerror=()=>{
        URL.revokeObjectURL(url);
        reject(new Error('image_decode_failed'));
      };
      image.src=url;
    });

    const canvasBlob=(canvas,quality)=>new Promise((resolve,reject)=>{
      canvas.toBlob(blob=>blob?resolve(blob):reject(new Error('image_encode_failed')),'image/jpeg',quality);
    });

    const optimisePhoto=async file=>{
      if(!file||!allowedTypes.includes(file.type))throw new Error('unsupported_type');
      if(file.size<=targetBytes&&file.type==='image/jpeg')return file;

      const image=await loadImage(file);
      const longest=Math.max(image.naturalWidth,image.naturalHeight);
      let scale=Math.min(1,maxDimension/longest);
      let width=Math.max(1,Math.round(image.naturalWidth*scale));
      let height=Math.max(1,Math.round(image.naturalHeight*scale));
      const canvas=document.createElement('canvas');
      const context=canvas.getContext('2d',{alpha:false});
      if(!context)throw new Error('canvas_failed');

      const draw=()=>{
        canvas.width=width;
        canvas.height=height;
        context.fillStyle='#fff';
        context.fillRect(0,0,width,height);
        context.imageSmoothingEnabled=true;
        context.imageSmoothingQuality='high';
        context.drawImage(image,0,0,width,height);
      };

      draw();
      let quality=.88;
      let blob=await canvasBlob(canvas,quality);

      while(blob.size>targetBytes&&quality>.58){
        quality-=.06;
        blob=await canvasBlob(canvas,quality);
      }

      while(blob.size>targetBytes&&Math.max(width,height)>1200){
        width=Math.max(1,Math.round(width*.88));
        height=Math.max(1,Math.round(height*.88));
        draw();
        blob=await canvasBlob(canvas,.72);
      }

      const base=(file.name||'photo').replace(/\.[^.]+$/,'');
      return new File([blob],base+'.jpg',{type:'image/jpeg',lastModified:Date.now()});
    };

    const validSelection=()=>{
      if(inputs.some(input=>!input.files||!input.files[0]))return false;
      return inputs.every(input=>allowedTypes.includes(input.files[0].type));
    };

    inputs.forEach(input=>input.addEventListener('change',()=>{
      const preview=input.parentElement.querySelector('img');
      if(preview.dataset.url)URL.revokeObjectURL(preview.dataset.url);
      const file=input.files&&input.files[0];
      preview.hidden=true;

      if(file&&allowedTypes.includes(file.type)){
        preview.dataset.url=URL.createObjectURL(file);
        preview.src=preview.dataset.url;
        preview.hidden=false;
        error.hidden=true;
      }else if(file){
        showError('Please use JPG, PNG or WEBP photos.');
      }
    }));

    form.addEventListener('submit',async event=>{
      if(form.dataset.tcSubmitting==='true')return;
      event.preventDefault();

      if(!form.checkValidity()){
        form.reportValidity();
        return;
      }

      if(!validSelection()){
        showError('Please add all 13 photos using JPG, PNG or WEBP files.');
        return;
      }

      error.hidden=true;
      button.disabled=true;
      progress.hidden=false;

      try{
        let total=0;

        for(let index=0;index<inputs.length;index++){
          progress.textContent='Preparing photo '+(index+1)+' of '+inputs.length+'…';
          const optimised=await optimisePhoto(inputs[index].files[0]);
          total+=optimised.size;

          if(typeof DataTransfer==='undefined')throw new Error('file_replace_unsupported');
          const transfer=new DataTransfer();
          transfer.items.add(optimised);
          inputs[index].files=transfer.files;
        }

        if(total>maxTotalBytes)throw new Error('total_too_large');

        progress.textContent='Adding your personalised frame to the basket…';
        form.dataset.tcSubmitting='true';
        HTMLFormElement.prototype.submit.call(form);
      }catch(uploadError){
        form.dataset.tcSubmitting='false';
        button.disabled=false;
        progress.hidden=true;
        showError('We couldn’t prepare one of your photos for upload. Please try again with JPG, PNG or WEBP photos.');
      }
    });

    window.addEventListener('pageshow',()=>{
      form.dataset.tcSubmitting='false';
      button.disabled=!form.querySelector('option:not([disabled])');
      progress.hidden=true;
    });
  });
}
initialiseTenderForms();
document.addEventListener('shopify:section:load',initialiseTenderForms);
function initialiseTenderGallery() {
  document.querySelectorAll('[data-tc-product]').forEach(root => {
    if (root.dataset.galleryReady) return;
    root.dataset.galleryReady = 'true';
    const select = root.querySelector('select[name="id"]');
    const pictures = [...root.querySelectorAll('[data-tc-gallery-image]')];
    const thumbnails = [...root.querySelectorAll('[data-tc-thumb]')];
    const colours = [...root.querySelectorAll('[data-tc-colour]')];
    const status = root.querySelector('[data-tc-colour-status]');
    if (!select || !pictures.length) return;
    const stage = root.querySelector('.tc-gallery-stage');
    const previous = root.querySelector('[data-tc-previous]');
    const next = root.querySelector('[data-tc-next]');
    const count = root.querySelector('[data-tc-count]');
    let activeIndex = 0;
    const updateControls = () => {
      activeIndex = pictures.reduce((best, picture, index) => Math.abs(picture.getBoundingClientRect().left - stage.getBoundingClientRect().left) < Math.abs(pictures[best].getBoundingClientRect().left - stage.getBoundingClientRect().left) ? index : best, 0);
      thumbnails.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.tcThumb === pictures[activeIndex].dataset.tcGalleryImage)));
      count.textContent = (activeIndex + 1) + ' / ' + pictures.length;
      previous.disabled = activeIndex === 0;
      next.disabled = activeIndex === pictures.length - 1;
    };
    const showImage = id => {
      const picture = pictures.find(picture => picture.dataset.tcGalleryImage === id);
      if (!picture) return;
      stage.scrollTo({left: stage.scrollLeft + picture.getBoundingClientRect().left - stage.getBoundingClientRect().left, behavior: 'instant'});
      updateControls();
    };
    previous.addEventListener('click', () => showImage(pictures[Math.max(0, activeIndex - 1)].dataset.tcGalleryImage));
    next.addEventListener('click', () => showImage(pictures[Math.min(pictures.length - 1, activeIndex + 1)].dataset.tcGalleryImage));
    stage.addEventListener('scroll', updateControls, {passive:true});
    stage.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        (event.key === 'ArrowRight' ? next : previous).click();
      }
    });
    new ResizeObserver(() => showImage(pictures[activeIndex].dataset.tcGalleryImage)).observe(stage);
    const syncColour = () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      showImage(option.dataset.tcImage);
      colours.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.tcColour === select.value)));
      const selected = colours.find(button => button.dataset.tcColour === select.value);
      if (status && selected) status.textContent = selected.querySelector('span').textContent + ' frame — front, side and back';
    };
    select.addEventListener('change', syncColour);
    colours.forEach(button => button.addEventListener('click', () => {
      const option = [...select.options].find(option => option.value === button.dataset.tcColour);
      if (!option) return;
      if (!option.disabled) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', {bubbles: true}));
      } else {
        showImage(button.dataset.tcImage);
        if (status) status.textContent = button.querySelector('span').textContent + ' frame preview — currently unavailable';
      }
    }));
    thumbnails.forEach(button => button.addEventListener('click', () => showImage(button.dataset.tcThumb)));
    window.addEventListener('pageshow', syncColour);
    syncColour();
  });
}
initialiseTenderGallery();
document.addEventListener('shopify:section:load', initialiseTenderGallery);


  } catch(e) { console.error(e); }
})();
})();
